export default __webpack_public_path__ + "static/media/contentful.e2ceac28.png";